import {Validator} from 'vee-validate';

const initPasswordRules = (errorMessage) => {
  Validator.extend('checkPassword', {
    getMessage: () => errorMessage,
    validate: (value) => {
      // Check whether the given password is 8 or more characters and contains at least one capital letter, one lowercase letter and a number.
      let regex = new RegExp('^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])\\S{8,}$');
      return regex.test(value);
    },
  });
};

export {initPasswordRules};
